/*
 * @@Author: MuYang
 */

export const $https = (function () {
  const _Vue = window.fe.vue
  return new _Vue().$http
})()

// 修改query
export function __changeQuery (target) {
  let v = window.vueInstantiation
  let currentQuery = v.$route.query
  // if (currentQuery.c) {
  let newQuery = JSON.parse(JSON.stringify(currentQuery))
  newQuery.c = JSON.stringify(target)
  v.$router.push({
    path: v.$route.path,
    query: newQuery
  })
  // }
}

export function isEmpty (val) {
  if (Array.isArray(val)) {
    return val.length === 0
  }
  return val === '' || val === undefined || val === null
}